import { DOC_TYPE_REQUIRED, DossierJsonldRead, Prescripteur } from '@europrocurement/l2d-domain';
import DocumentContext from '@europrocurement/l2d-modules/modules/Dossiers/providers/DocumentContext';

import useDossierFile from '@europrocurement/l2d-modules/modules/Dossiers/hooks/useDossierFile';
import { DisplayedDocument } from '@europrocurement/l2d-modules/modules/Dossiers/providers/types';
import { Box } from '@mui/system';
import React, { useContext, useEffect, useState } from 'react';
import RequiredDocumentsList from '@europrocurement/l2d-modules/modules/Dossiers/components/detail/RequiredDocumentsList/RequiredDocumentsList';
import RequiredDocumentUploader from '@europrocurement/l2d-modules/modules/Dossiers/components/detail/RequiredDocumentUploader/RequiredDocumentUploader';
import { useDocumentSign } from '@europrocurement/l2d-modules/modules/Dossiers';
import { enqueueSnackbar } from 'notistack';

interface DocToSendProps {
    dossier: DossierJsonldRead;
    prescripteur: Prescripteur;
}

export const DocToSend: React.FunctionComponent<DocToSendProps> = function ({
    dossier,
    prescripteur,
}) {
    const [uploadingAdditionalDocument, setUploadingAdditionalDocument] = useState<boolean>(false);
    const [listItems, setListItems] = useState<Array<DisplayedDocument>>([]);
    const {
        documents,
        fichiers,
        getPrescriberDocuments,
        getPrescriberAdditionalDocuments,
        setDossierFromParcours,
    } = useContext(DocumentContext);
    const { handleSignSingleDocument } = useDocumentSign();

    const handleSignSingleDocProxy = (label: string, fichierId: number, fileName?: string) => {
        const mainContact = prescripteur.contacts.find((c) => c.principal);
        const mainEmail = (mainContact?.emailsContact || []).find((email) => email?.defaut);

        if (!mainEmail) {
            enqueueSnackbar(
                'Impossible de trouver un contact avec une adresse email valide auquel rattacher ce dossier de signature électronique',
                { variant: 'error' },
            );

            return;
        }

        handleSignSingleDocument(
            dossier.id as number,
            prescripteur.id as number,
            prescripteur.raisonSociale as string,
            mainEmail?.email as string,
            label,
            fichierId,
            fileName,
        );
    };

    useEffect(() => {
        setDossierFromParcours(dossier);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dossier]);

    useEffect(() => {
        const items = [...getPrescriberDocuments(), ...getPrescriberAdditionalDocuments()].map(
            (item) => ({
                ...item,
                movable: false,
            }),
        );

        setListItems(items);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [documents, fichiers]);

    const { handleAddFile, handleRemoveFile, handleShow, handleDownload, handleAdditionalUploads } =
        useDossierFile({
            listItems,
            setListItems,
            setUploadingAdditionalDocument,
            typeDoc: DOC_TYPE_REQUIRED,
            dossierProps: dossier,
        });

    return (
        <Box sx={{ display: 'grid', gap: '8px 0' }}>
            <RequiredDocumentsList
                documents={listItems}
                onUpload={handleAddFile}
                onDeletion={handleRemoveFile}
                onDownload={handleDownload}
                onShow={handleShow}
                onSign={handleSignSingleDocProxy}
                onMove={() => {}}
                onDocDeletion={() => {}}
            />
            <RequiredDocumentUploader
                uploading={uploadingAdditionalDocument}
                onChange={handleAdditionalUploads}
            />
        </Box>
    );
};

export default DocToSend;
